import Controller from "./contractVersioning.controller";
import template from "./contractVersioning.html";

const contractVersioning = {
  template,
  controller: Controller,
  bindings: {
    selectedContract: "<",
    contractVersions: "<",
    activeVersion: "<",
    isInitialContractLoading: "<",
    currentVersion: "<",
  },
};

export default contractVersioning;



// WEBPACK FOOTER //
// ./src/components/contractVersioning/contractVersioning.component.js